import * as postLiveModule from './postLiveReason'

// ACTIONS
export const INITIALISE_DASHBOARD_STATE = 'candidateExperience/INITIALISE_DASHBOARD_STATE'

export const SUBMIT_FOR_REVIEW_SUCCESS = 'offerzen/dashboard/SUBMIT_FOR_REVIEW_SUCCESS'

// ACTION CREATORS
export const initialiseDashboardState = initialState => ({
  type: INITIALISE_DASHBOARD_STATE,
  payload: initialState,
})

export const submitForReviewSuccess = ({ dashboard_state }) => {
  return {
    type: SUBMIT_FOR_REVIEW_SUCCESS,
    payload: {
      dashboard_state,
    },
  }
}

// REDUCERS
const initialState = {}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALISE_DASHBOARD_STATE:
      return {
        ...state,
        ...action.payload,
      }

    case postLiveModule.SUBMIT_REASON:
      return {
        ...state,
      }

    case postLiveModule.SUBMIT_REASON_SUCCESS:
    case SUBMIT_FOR_REVIEW_SUCCESS:
      return {
        ...state,
        ...action.payload.dashboard_state,
        loading: action.payload.loading,
      }

    default:
      return state
  }
}

export default dashboardReducer
